import { render } from "./milestone-stage-status-item.vue?vue&type=template&id=5844e514&ts=true"
import script from "./milestone-stage-status-item.vue?vue&type=script&lang=ts"
export * from "./milestone-stage-status-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__